import React from 'react';
import Icon from '@mdi/react';

const parseIconSize = (fontSize) => {
  if (typeof fontSize === 'number') {
    return fontSize / 24;
  }
  const px = parseFloat(fontSize);
  return Number.isFinite(px) ? px / 24 : 0.85;
};

export function createMdiMenuIcon(path) {
  function MdiMenuIcon({ style = {} }) {
    const { fontSize, color, ...restStyle } = style;
    const resolvedColor = !color || color === 'inherit' ? 'currentColor' : color;

    return (
      <Icon
        path={path}
        size={parseIconSize(fontSize)}
        color={resolvedColor}
        style={{
          flexShrink: 0,
          display: 'block',
          color: color || 'inherit',
          ...restStyle,
        }}
        className="sidebar-mdi-icon"
      />
    );
  }

  MdiMenuIcon.displayName = 'MdiMenuIcon';
  return MdiMenuIcon;
}
